












































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import * as _ from "lodash";
import Pagination from "@/components/paginaiton.vue";
import MainHeader from "../../../../main/components/main-header/main-header.vue";
import NavLeft from "../../components/nav-left.vue";
import {
  DeleteTongue,
  GetHospitals,
  GetTonguePicLists,
  DeleteSomeTongues,
  GetTongueTemplates,
  GetTongueTopicsOfTemplate,
} from "@/request/tongue";
import PicList from "./picList.vue";
import TextList from "./textList.vue";
@Component({
  components: {
    Pagination,
    MainHeader,
    NavLeft,
    PicList,
    TextList,
  },
})
export default class TongueList extends Vue {
  private listType: any = "pic";
  private filters: any = {
    hospital_ids: [],
    范围: [],
    search: "",
    性别: "",
    开始时间: "",
    结束时间: "",
    年龄段: [],
    timeWay: "",
    time: [],
    条件: "",
    研究指标: [],
    自定义年龄: [false],
    时间段: "",
    自定义时间段: [false, []],
    currentPage: 1,
    orderField: "创建时间",
    orderValue: 0,
    pageCount: 12,
    primaryFilters: {},
    totalCount: 0,
    ifPrimarySearched: false,
  };
  private hospitals: any[] = [];
  private tongues: any[] = [];
  // 高级筛选
  private ifShowPrimarySearch: boolean = false;
  private searchedTemplates: any[] = [];
  private setFilters() {
    localStorage.setItem("tongueListFilters", JSON.stringify(this.filters));
  }
  // @Watch("$store.state.token")
  // private tokenChange() {
  //   this.filters.currentPage = 1;
  //   this.fetchHospitals();
  //   this.fetchTongueList();
  // }
  /**
   * @description 改变列表展示的形式
   */
  private changeListType(type) {
    this.listType = type;
  }
  /**
   * @description 获得可选医院列表
   */
  private fetchHospitals() {
    GetHospitals(this).then((data: any) => {
      this.hospitals = data;
      this.hospitals.unshift({ hospital_id: "", 医院名称: "全部医院" });
    });
  }
  /**
   * @description 改变排序顺序
   */
  private changeOrderValue() {
    this.filters.orderValue = this.filters.orderValue === 0 ? 1 : 0;
    this.search();
  }
  /**
   * @description 获得舌图图片列表
   */
  private fetchTongueList() {
    // hospital_ids
    this.filters.hospital_ids = [];
    this.filters["范围"].forEach((item: any) => {
      this.filters.hospital_ids.push(item);
    });
    if (this.filters.hospital_ids.includes("")) {
      this.filters.hospital_ids = [];
    }
    const params = _.cloneDeep(this.filters);
    params["current_page"] = this.filters.currentPage;
    params["order_field"] = this.filters.orderField;
    params["order_value"] = this.filters.orderValue;
    params["page_count"] = this.filters.pageCount;
    // 时间段
    if (this.filters.timeWay === "自定义") {
      params["开始时间"] = this.filters.time[0];
      params["结束时间"] = this.filters.time[1];
      this.filters.ifPrimarySearched = true;
    }
    if (this.filters["研究指标"].length > 0) {
      this.filters.ifPrimarySearched = true;
      const arr: any[] = [];
      this.filters["研究指标"].map((item: any) => {
        const i = JSON.parse(JSON.stringify(item.selected));
        i.condition = item.result.condition;
        i.value = item.result.value;
        arr.push(i);
      });
      params["研究指标"] = arr;
    }
    GetTonguePicLists(this, params).then((data: any) => {
      // console.log(data);
      data.tongues.forEach((tongue: any) => {
        tongue.selected = false;
      });
      this.$set(this, "tongues", data.tongues);
      this.filters.totalCount = data.total_count;
      this.setFilters();
    });
  }
  /**
   * @description 搜索
   */
  private search() {
    this.filters.currentPage = 1;
    this.fetchTongueList();
  }
  /**
   * @description 打开高级筛选
   */
  private openPrimarySearch() {
    this.fetchTemplates();
    this.ifShowPrimarySearch = true;
  }
  /**
   * @description 处理高级筛选
   */
  private primaryFilterChange(val) {
    this.ifShowPrimarySearch = false;
    this.$set(this, "filters", val);
    this.filters.currentPage = 1;
    this.filters.ifPrimarySearched = true;
    this.fetchTongueList();
  }
  /**
   * @description 添加研究指标变量
   */
  private addTiaojian() {
    this.filters["研究指标"].push({ result: {}, selected: {} });
  }
  /**
   * @description 获取当前分组下的可选模板列表
   */
  private fetchTemplates() {
    GetTongueTemplates(this).then((data: any) => {
      this.searchedTemplates = data;
    });
  }
  /**
   * @description 搜索模板下具体的字段
   */
  private searchItems(l) {
    GetTongueTopicsOfTemplate(this, l.template_id).then((data: any) => {
      l.items = data;
      this.$forceUpdate();
    });
  }
  /**
   * @description 删除一个条件
   */
  private deleteTiaojian(index: any) {
    this.filters["研究指标"].splice(index, 1);
  }
  /**
   * @description 重置高级筛选条件
   */
  private resetPrimarySearch() {
    this.$set(this, "filters", {
      hospital_ids: [],
      范围: [],
      姓名: "",
      性别: "",
      开始时间: "",
      结束时间: "",
      年龄段: [],
      timeWay: "",
      time: [],
      条件: "",
      研究指标: [],
      自定义年龄: [false],
      时间段: "",
      自定义时间段: [false, []],
      currentPage: 1,
      orderField: "创建时间",
      orderValue: 0,
      pageCount: 12,
      primaryFilters: {},
      totalCount: 0,
      ifPrimarySearched: false,
    });
    this.fetchTongueList();
  }
  /**
   * @description 取消高级筛选
   */
  private cancelPrimarySearch() {
    this.ifShowPrimarySearch = false;
  }
  /**
   * @description 确定高级筛选
   */
  private confirmPrimarySearch() {
    this.ifShowPrimarySearch = false;
    this.filters.currentPage = 1;
    this.filters.ifPrimarySearched = true;
    this.fetchTongueList();
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val) {
    this.filters.currentPage = val;
    this.fetchTongueList();
  }
  /**
   * @description 切换一个舌图的选中状态
   */
  private triggerOneTongue(tongue) {
    tongue.selected = !tongue.selected;
  }
  /**
   * @description 预览舌图报告
   */
  private previewTongue(tongue) {
    this.$router.push({
      path: "/main/tongue/tongue-preview",
      query: {
        tongue_id: tongue.tongue_id,
      },
    });
  }
  /**
   * @description 全选
   */
  private selectAll() {
    this.tongues.forEach((tongue: any) => {
      tongue.selected = true;
    });
  }

  /**
   * @description 删除某一个舌图
   */
  private deleteTongue(tongue) {
    const params = {
      data: {
        tongue_id: tongue.tongue_id,
      },
    };
    DeleteTongue(this, params).then((data: any) => {
      this.$message.success("已放入回收站");
      this.fetchTongueList();
    });
  }
  /**
   * @description 删除多张舌图
   */
  private deleteSomeTongues() {
    const arr: any[] = [];
    this.tongues.forEach((tongue: any) => {
      if (tongue.selected) {
        arr.push(tongue.tongue_id);
      }
    });
    if (arr.length > 0) {
      const params: any = {
        data: {
          tongue_ids: arr,
        },
      };
      DeleteSomeTongues(this, params).then(() => {
        this.$message.success("已全部放入回收站");
        this.fetchTongueList();
      });
    }
  }
  /**
   * @description 初始化
   */
  private mounted() {
    const localFilters = localStorage.getItem("tongueListFilters");
    if (!localFilters) {
      this.$set(this, "filters", {
        hospital_ids: [],
        范围: [],
        姓名: "",
        性别: "",
        开始时间: "",
        结束时间: "",
        年龄段: [],
        timeWay: "",
        time: [],
        条件: "",
        研究指标: [],
        自定义年龄: [false],
        时间段: "",
        自定义时间段: [false, []],
        currentPage: 1,
        orderField: "创建时间",
        orderValue: 0,
        pageCount: 12,
        primaryFilters: {},
        totalCount: 0,
        ifPrimarySearched: false,
      });
    } else {
      this.$set(this, "filters", JSON.parse(localFilters));
    }
    this.fetchHospitals();
    this.fetchTongueList();
  }
}
